"use strict";
exports.__esModule = true;
exports.ProductionPlanBuilder = void 0;
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var DesignerAssets_1 = require("../base/DesignerAssets");
var ProductionPlanBuilder = /** @class */ (function () {
    function ProductionPlanBuilder(productionPlan) {
        this.productionPlan = productionPlan;
        this.productionPlanAssetsBuilder = DesignerAssets_1.DesignerAssetsBuilder.initialiseWithEmptyAssets();
    }
    ProductionPlanBuilder.initiateWithEmptyPlan = function () {
        return new ProductionPlanBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            piecePlans: [],
            accessoryPlans: [],
            assets: {
                fonts: [],
                symbols: [],
                symbolCollections: [],
                pieces: [],
                accessories: []
            }
        });
    };
    ProductionPlanBuilder.prototype.getId = function () {
        return this.productionPlan.id;
    };
    ProductionPlanBuilder.prototype.withId = function (id) {
        this.productionPlan.id = id;
        return this;
    };
    ProductionPlanBuilder.prototype.addPiecePlan = function (productionItemPiece, itemAssets) {
        this.productionPlan.piecePlans.push(productionItemPiece);
        this.productionPlanAssetsBuilder.concat(itemAssets);
        this.productionPlan.assets = this.productionPlanAssetsBuilder.build();
        return this;
    };
    ProductionPlanBuilder.prototype.addAccessoryPlan = function (productionItemAccessory, itemAssets) {
        this.productionPlan.accessoryPlans.push(productionItemAccessory);
        this.productionPlanAssetsBuilder.concat(itemAssets);
        this.productionPlan.assets = this.productionPlanAssetsBuilder.build();
        return this;
    };
    ProductionPlanBuilder.prototype.build = function () {
        return this.productionPlan;
    };
    return ProductionPlanBuilder;
}());
exports.ProductionPlanBuilder = ProductionPlanBuilder;
